var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInduction = function SvgInduction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#induction_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 19,
    x: 19.5,
    y: 3.5,
    stroke: "currentColor",
    rx: 1.5,
    transform: "rotate(90 19.5 3.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 8.5,
    y: 7,
    stroke: "currentColor",
    rx: 2.5,
    transform: "rotate(90 8.5 7)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 1.5,
    x: 6.75,
    y: 8.75,
    fill: "currentColor",
    rx: 0.75,
    transform: "rotate(90 6.75 8.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 16.5,
    y: 7,
    stroke: "currentColor",
    rx: 2.5,
    transform: "rotate(90 16.5 7)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 1.5,
    x: 14.75,
    y: 8.75,
    fill: "currentColor",
    rx: 0.75,
    transform: "rotate(90 14.75 8.75)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "induction_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgInduction;